import { styled as i, DialogTitle as e, colors as a, shippoTheme as t, Box as p, DialogContent as s, IconButton as l, DialogActions as d, Dialog as r } from "@goshippo/components";
const c = i(e, {
  shouldForwardProp: (o) => o !== "hasTitle"
})`
  border-bottom: ${({ hasTitle: o }) => o ? `solid 1px ${a.gray30}` : "none"};
  margin-bottom: ${({ hasTitle: o }) => o ? t.spacing(4) : 0};
  padding: ${t.spacing(2)};
  padding-left: ${t.spacing(3)};
  padding-bottom: ${({ hasTitle: o }) => o ? t.spacing(2) : 0};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
`, $ = i(p)`
  display: flex;
  gap: ${({ theme: o }) => o.spacing(1)};
`, y = i("span")`
  display: flex;
  align-items: center;
`, m = i(s)`
  padding-bottom: ${t.spacing(4)};
`, f = i(l)`
  color: ${a.gray60};
  padding: ${t.spacing(1)};
`, u = i(d, {
  shouldForwardProp: (o) => o !== "hasSingleAction"
})`
  display: flex;
  border-top: solid 1px ${a.gray30};
  padding: ${t.spacing(1.5, 3)};
  gap: ${t.spacing(2)};
  justify-content: ${({ hasSingleAction: o }) => o ? "flex-end" : "space-between"};

  ${t.breakpoints.down("sm")} {
    > * {
      width: 100%;
      margin: 0;
      flex: 1 1 auto;
      flex-wrap: wrap;
    }

    > :not(:first-of-type) {
      margin: 0;
    }
  }
`, x = i(r, {
  shouldForwardProp: (o) => !["expanded", "fitContent"].includes(o)
})`
  & .MuiDialog-paper {
    border-radius: ${t.spacing(2)};
  }

  ${t.breakpoints.up("sm")} {
    & .MuiDialog-paper {
      max-width: ${({ fitContent: o }) => o ? "fit-content" : t.spacing(75)};
    }
  }

  ${({ fitContent: o, expanded: n }) => (o || n) && `
    ${t.breakpoints.up("xl")} {
      & .MuiDialog-paper {
        max-width: ${o ? "fit-content" : t.spacing(100)};
      }
    }
  `}
`;
export {
  u as StyledDialogActions,
  m as StyledDialogContent,
  c as StyledDialogTitle,
  x as StyledDialogWrapper,
  f as StyledIconButton,
  y as StyledIconWrapper,
  $ as StyledTitle
};
//# sourceMappingURL=Dialog.styled.js.map
